/* HCORZ
=========================================================================================
* Descripción: 
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revisión   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 07/06/2025 | Lic. José Luis Aragón Cervantes  | Creación
* ---------------------------------------------------------------------------------------
*/

import { createContext, useContext, useEffect, useState } from "react";
import { useLayout } from '../../context/System/LayoutContext'
import { useSesion } from "../System/SesionContext";

import { useNavigate } from "react-router-dom";
import { HelpOutlineRounded, TrendingUpRounded } from "@mui/icons-material";
import { getPickersYearUtilityClass } from "@mui/x-date-pickers/YearCalendar/pickersYearClasses";

import { format } from "date-fns";
import { dateTimePickerTabsClasses } from "@mui/x-date-pickers";

export const ToolsContext = createContext();
export const ToolsProvider = (props) => {    
    const navigation = useNavigate();
    const { handleOpenAlert } = useLayout();
    const [statusWaiting, setStatusWaiting]= useState(false);

    const handleClickRegresarMainDashboard=()=>{
        const route = "/*";
        navigation(route);
    };
    
    return (
        <ToolsContext.Provider
            value={{
                handleClickRegresarMainDashboard,
                statusWaiting, setStatusWaiting,
            }}
        >
            {props.children}
        </ToolsContext.Provider>
    );
};

export const useTools = () => useContext(ToolsContext);
